import axios from "axios";
import Cookies from "js-cookie";
import { dataFormatter } from "../admin";
import {
  convertToCamelCase,
  convertToSnakeCase,
} from "../../redux/actions/helpers";

export const createApplication = async (formData) => {
  const response = await axios
    .post(
      "/api/v1/applications",
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const updateApplication = async (formData, id) => {
  const response = await axios
    .put(
      `/api/v1/applications/${id}`,
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const loadApplications = async (page) => {
  const response = await axios
    .get(`/api/v1/applications?page=${page}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    const meta = JSON.parse(response.request.response)["meta"];
    const results = dataFormatter.deserialize(response.data).map((obj) => {
      return convertToCamelCase(obj);
    });

    return { results: results, meta: meta };
  }
};

export const loadApplication = async (id, withDashboard=false) => {
  const response = await axios
    .get(`/api/v1/applications/${id}?withDashboard=${withDashboard}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const destroyApplication = async (id) => {
  const response = await axios
    .delete(`/api/v1/applications/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};
